import {Component, Inject, NgModule, OnInit} from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DelegacionService } from '../services/bd/Delegacion/delegacion.service';
import { AnexoDelegacion } from '../models/AnexoDelegacion';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'ral-buscador-taller',
  templateUrl: './buscador-taller.component.html',
  styleUrls: ['./buscador-taller.component.scss'],
})
export class BuscadorTallerComponent extends VentanaFlotante  implements OnInit
{

  apiGoogle = environment.googleMapsApiKey;
  displayedColumns :string[] = ["delegacion","nombre","cp","direccion","distanciaKm","razon_social","latitud","longitud","poblacion","provincia","ruta"]
  dataSource: any[]=[];
  webUrl: SafeResourceUrl = "";
  latitud:number=0;
  longitud:number=0;
  talleres:TallerCercano[]=[];
  mostrarMapa:boolean = false;
  cargaSinResultados:boolean = false;
  urlBase = "https://workshops.ralarsa.com/nou/ralarsa/mapas/CargarMapa.php?oper=puntos&addr=";
  unidadMovil: string = ""
  constructor(
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private sanitizer:DomSanitizer, // Additional parameter to override in the constructor,
    private delegacionService : DelegacionService,
    private http:HttpClient
  )
  {
    super(dialogRef, data); // Call the parent class constructor
    this.unidadMovil = data.unidadMovil;
  }
  ngOnInit()
  {
    //alert(this.data.lat)
    this.getGeocodeResults(this.data.direccionBusqueda).subscribe((results: Coordenada) =>
    {
        this.latitud = results.latitude;
        this.longitud = results.longitude;
        this.recogerDelegaciones();
    });
  }
  //busca las delegaciones
  recogerDelegaciones()
  {
    let params=
    {
      "parameters":
      [
        [{
            campo: "ad.delegacion",
            operacion: "NOT IN",
            valor2: ["7", "1", "970"]
        }],
        [{
            campo: "ad.delegacion",
            operacion: "<",
            valor: "599"
        }],
        [{
            campo: "ad.latitud",
            operacion: "!=",
            valor: "null"
        }],
        [{
            campo: "ad.longitud",
            operacion: "!=",
            valor: "null"
        }],
        [{
            campo: "d.par_010",
            operacion: "!=",
            valor: "S"
        }]
      ],
      "select": ["distinct ad.delegacion","UPPER(ad.nombre) as nombre","ad.cp","ad.direccion","ad.razon_social","ad.latitud","ad.longitud","ad.poblacion","ad.provincia"],
      "orden": [["ad.delegacion","ASC"]]
    };

    if (this.unidadMovil != "" && this.unidadMovil == "um"){
      params.parameters.push([{
        campo: "ad.unidad_movil",
        operacion:  "=",
        valor: "SI"
      }])
    }
    let listadoCompleto:AnexoDelegacion[]=[];
    let talleresCercanos:TallerCercano[]=[];
    this.delegacionService.getDelegacionesCustom(this.data.token, params)
    .then(res=>
      {
        listadoCompleto = res;
        listadoCompleto.forEach(d =>
        {
          //let distancia = this.calcularDistancia(this.data.lat,this.data.lon,d.latitud,d.longitud,false)
          let distancia = this.getDistanciaKm(this.latitud,this.longitud,d.latitud,d.longitud);
          if ( distancia < this.data.km)
          {
            let c :TallerCercano =
            {
              delegacion:d.delegacion,
              distanciaKm:Number(distancia.toFixed(2)),
              latitud:parseFloat(d.latitud,),
              longitud:parseFloat(d.longitud),
              cp:d.cp.trim(),
              direccion: d.direccion == null ? "" : d.direccion.trim(),
              nombre:d.nombre.trim(),
              poblacion:d.poblacion.trim(),
              provincia:d.provincia.trim()
            }
            talleresCercanos.push(c)
          }
        });

        //MIRAMOS el listado de encontrados y lo ordenamos
        // de menor a mayor distancia de KM
        //Si hay más de 5 talleres, nos quedamos solo con
        // los 5 primeros
        talleresCercanos.sort(this.compareByDistancia);
        let temp = talleresCercanos.splice(0, 5);
        this.talleres=temp;
        this.dataSource = this.talleres;
        if(this.dataSource.length == 0 ){
          this.dialogRef.close("pato");
        }
        this.cargarPuntosUrl();
      })

  }

  getDistanciaKm(latitudActual:number,longitudActual:number,latTaller:string,lonTaller:string)
  {
    const earthRadiusKm = 6371; // Earth's radius in kilometers

    // Convert degrees to radians
    let lat1Rad = this.degreesToRadians(latitudActual);
    let lon1Rad = this.degreesToRadians(longitudActual);
    let lat2Rad = this.degreesToRadians(parseFloat(latTaller));
    let lon2Rad = this.degreesToRadians(parseFloat(lonTaller));

    // Calculate differences between coordinates
    let latDiff = lat2Rad - lat1Rad;
    let lonDiff = lon2Rad - lon1Rad;
     // Calculate distance using Haversine formula
    let a =
              Math.sin(latDiff / 2) * Math.sin(latDiff / 2) +
              Math.cos(lat1Rad) * Math.cos(lat2Rad) * Math.sin(lonDiff / 2) * Math.sin(lonDiff / 2);
    let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return earthRadiusKm * c;
  }

  degreesToRadians(degrees: number): number {return (degrees * Math.PI) / 180;}

  //reordena por distancia el array de talleres cercano
  private compareByDistancia(a: TallerCercano, b: TallerCercano): number
  {return a.distanciaKm - b.distanciaKm;}


  //devuelve las coordenadas de la direccion/CP cliente
  getGeocodeResults(direccion:string): Observable<Coordenada>
  {
    let url =
      'https://maps.google.com/maps/api/geocode/json?address=' +
      direccion +
      '&amp;region=es&language=es&sensor=false&components=country:ES&key=' +
      this.apiGoogle;
    return this.http.get(url).pipe(
      map((response: any) =>
      {
        let results = response.results;
        if (results && results.length > 0)
        {
          let location = results[0].geometry.location;
          return {latitude: location.lat,longitude: location.lng};
        }
        return {latitude:0,longitude:0};
      })
    );
  }

  //carga en la url final los puntos-taller que se deben de mostrar
  cargarPuntosUrl()
  {
    let puntosUrl = "";

    for (let i = 0; i < this.talleres.length; i++)
    {
      let t = this.talleres[i];
      puntosUrl+= "&punto"+i+"="+t.latitud+","+t.longitud+"@"+t.delegacion
      +"@"+t.direccion+","+t.cp+","+t.poblacion;
    }
    this.webUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.urlBase+this.latitud+","+this.longitud+puntosUrl);
    this.mostrarMapa = true;
  }

  calcularRuta(taller:TallerCercano)
  {
    let urlRuta = "https://workshops.ralarsa.com/nou/ralarsa/mapas/CargarMapa.php?oper=ruta&addr="
    +this.latitud+"|"+this.longitud+"&dest="+taller.latitud+"|"+taller.longitud;

    let  windowFeatures = "width=700,height=700,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no";

    window.open(urlRuta,"_blank",windowFeatures);

    // TODO: abrir tambien las indicaciones
    this.mostrarInstrucciones(taller);
  }

  //vuelca  el taller seleccionado en el form principal
  volcarTallerSeleccionado(filaSeleccionada:TallerCercano)
  {
    //Cargamos los datod de la delegacion (unidad movil )seleccionada
    this.delegacionService.getDatosDelegacion(this.data.token,filaSeleccionada.delegacion)
    .then(res=>{this.dialogRef.close(res);});
  }

  mostrarInstrucciones(taller:TallerCercano)
  {
    const ubicacionOrigen = this.latitud+","+this.longitud;
    const ubicacionDestino = taller.latitud+","+taller.longitud;
    const dirTaller=taller.direccion.replace(" ","+");
    let url = "https://maps.googleapis.com/maps/api/directions/json?origin="
    + ubicacionOrigen + "&destination="+ ubicacionDestino + "&key=" + this.apiGoogle + "&&language=es";

    //const urlMaps = "https://www.google.com/maps/dir/42.8162,-1.747/RALARSA+HOLDING+SL,+Carretera+de+Rub%C3%AD,+3,+Sant+Quirze+del+Vall%C3%A8s/@42.1408274,-1.1752031,8z/data=!3m2!4b1!5s0x12a495d2c5325ea3:0x5aa578eece6b8dae!4m10!4m9!1m1!4e1!1m5!1m1!1s0x12a493d023c00001:0x3629d1a8cd25f103!2m2!1d2.0357144!2d41.5130438!3e2?entry=ttu";


    let urlMaps = "https://www.google.com/maps/dir/";
/*
  1. **Directions Path**: `/dir/42.8162,-1.747/RALARSA+HOLDING+SL,+Carretera+de+Rub%C3%AD,+3,+Sant+Quirze+del+Vall%C3%A8s`
   - This part of the URL specifies the directions path.
   It includes the starting point coordinates (`42.8162,-1.747`)
   and the destination address (`RALARSA HOLDING SL, Carretera de Rubí, 3, Sant Quirze del Vallès`).

  2. **Location Coordinates**: `@42.1408274,-1.1752031,8z`
   - This parameter represents the coordinates of a specific location on the map.
   In this case, it corresponds to a point with latitude `42.1408274` and longitude `-1.1752031`.
   The `8z` indicates the zoom level of the map.

  3. **Data Parameter**: `data=!3m2!4b1!5s0x12a495d2c5325ea3:0x5aa578eece6b8dae!4m10!4m9!1m1!4e1!1m5!1m1!1s0x12a493d023c00001:0x3629d1a8cd25f103!2m2!1d2.0357144!2d41.5130438!3e2`
  - This parameter contains encoded data about the map location and other information.

  4. **Entry Parameter**: `entry=ttu` -
  This parameter specifies the entry point for a user.
  In this case, `ttu` indicates the user entered from a third-party website.
*/
    urlMaps+=ubicacionOrigen+"/"+dirTaller+"/@"+ubicacionDestino+",8z/"
    +"?entry=ttu";
    let  windowFeatures = "width=1000,height=700,toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no";
    window.open(urlMaps,"_blank",windowFeatures);
  }


}
export interface Coordenada{latitude:number,longitude:number}
export interface TallerCercano
{
  delegacion:number;
  nombre:string;
  direccion:string;
  cp:string;
  provincia:string;
  poblacion:string;
  distanciaKm:number;
  latitud:number;longitud:number;
}
